import { MakeCall } from './createMakeCall';

const unpublishListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('PUT', `/api/v2/listing/${listingId}/unpublish`);
export { unpublishListing };
